import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, Drawer, IconButton, FormControl, RadioGroup, Radio } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonDeleteButton, CommonEditButton, CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import CommonValidation from '../../../Components/CommonFunctions/CommonValidation'
import { AmountFormat } from '../../../Components/CommonFunctions/CommonFunctions'
import { CurrencySymbol, gstPercentage } from '../../../Utility/Constants'
import { ImagePaths } from '../../../Utility/ImagePaths'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PrintIcon from '@mui/icons-material/Print';

const active_status = [{ label: "All", value: "" }, { label: "Active", value: "true" }, { label: "In Active", value: "false" }]

export default function StoreProduct() {
    const [productList, setProductList] = useState([]);
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [departmentName, setdepartmentName] = useState(null);
    const [departmentList, setdepartmentList] = useState([]);
    const [CategoryName, setCategoryName] = useState(null);
    const [CategoryList, setCategoryList] = useState([]);
    const [subCategoryName, setSubCategoryName] = useState(null);
    const [subCategoryList, setSubCategoryList] = useState([]);
    const [productType, setProductType] = useState(null);
    const [productTypeList, setProductTypeList] = useState([]);
    const [uomList, setUomList] = useState([]);
    const [ProductCode, setProductCode] = useState('');
    const [ProductName, setProductName] = useState('');
    const [CommonName, setCommonName] = useState('');
    const [ShortName, setShortName] = useState('');
    const [ManufactureName, setManufactureName] = useState('');
    const [ModelName, setModelName] = useState('');
    const [ROL, setROL] = useState('');
    const [ROQ, setROQ] = useState('');
    const [GST, setGST] = useState(null);
    const [uom, setUom] = useState(null);
    const [HSN, setHSN] = useState('');
    const [expiry, setexpiry] = useState('non_expiry');
    const [filterdepartmentName, setfilterdepartmentName] = useState(null);
    const [filterCategoryName, setfilterCategoryName] = useState(null);
    const [filterSubCatName, setfilterSubCatName] = useState(null);
    const [filterProductTypeName, setfilterProductTypeName] = useState(null);
    const [filterManuFacName, setfilterManuFacName] = useState(null);
    const [filterActiveStatus, setFilterActiveStatus] = useState({ label: "All", value: "" });
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [EditID, setEditID] = useState(null);
    const [isloader, setisloader] = useState(false);
    const [isActive, setIsActive] = useState(true);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [filterOpen, setFilterOpen] = useState(false);
    const [filtervendorCategory, setFilterVendorCategory] = useState('');


    useEffect(() => {
        getdepartmentList()
        getcategoryList()
        getsubcategoryList()
        getProductType()
        getProductUom()
        getProductList()
    }, [])


    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }

    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const getProductList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(`${Serviceurls.STORE_PRODUCT}?dept_id=${filterdepartmentName ? filterdepartmentName?.id : ""}&category_id=${filterCategoryName ? filterCategoryName?.id : ""}&sub_category_id=${filterSubCatName ? filterSubCatName?.id : ""}&product_type_id=${filterProductTypeName ? filterProductTypeName?.id : ""}&manufacturer_name=${filterManuFacName ? filterManuFacName : ""}&status=${filterActiveStatus?.value}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        const filData = response.data.data
                        setProductList(response.data.data || [])
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getdepartmentList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_DEPARTMENT)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setdepartmentList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getcategoryList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setCategoryList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getsubcategoryList = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_SUB_CATEGORY)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setSubCategoryList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getProductType = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_PRODUCT_TYPE)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setProductTypeList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const getProductUom = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.STORE_PRODUCT_UOM)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setUomList(response.data.data?.filter((item) => item?.is_active) || [])
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'departmentName':
                setdepartmentName(val);
                setCategoryName(null);
                setSubCategoryName(null);
                break
            case 'CategoryName':
                setCategoryName(val);
                break
            case 'subCategoryName':
                setSubCategoryName(val);
                break
            case 'productType':
                setProductType(val);
                break
            case 'GST':
                setGST(val);
                break
            case 'uom':
                setUom(val);
                break
        }
    }

    const onChangeHandler = (e, name) => {
        let value = e.target.value
        switch (name) {
            case 'ProductName':
                if (value === "" || value.length <= 50) {
                    setProductName(value)
                }
                break
            case 'CommonName':
                if (value === "" || value.length <= 50) {
                    setCommonName(value)
                }
                break
            case 'ShortName':
                if (value === "" || value.length <= 50) {
                    setShortName(value)
                }
                break
            case 'ManufactureName':
                if (value === "" || value.length <= 50) {
                    setManufactureName(value)
                }
                break
            case 'ModelName':
                if (value === "" || value.length <= 50) {
                    setModelName(value)
                }
                break
            case 'ROL':
                if (value === "" || (CommonValidation.numberOnly(value) && value?.length <= 5)) {
                    setROL(value)
                }
                break
            case 'ROQ':
                if (value === "" || (CommonValidation.numberOnly(value) && value?.length <= 5)) {
                    setROQ(value)
                }
                break
            case 'HSN':
                if (value === "" || value.length <= 10) {
                    setHSN(value)
                }
                break
            case 'filterManuFacName':
                if (value === "" || value.length <= 50) {
                    setfilterManuFacName(value)
                }
                break
        }
    }

    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    disabled={disable}
                    value={val ? val : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width, disable = false) => {
        return (
            <Box>
                <Autocomplete
                    size={'small'}
                    options={list}
                    name={name}
                    disabled={disable}
                    freeSolo={name === "uom"}
                    getOptionLabel={(option) => name === 'departmentName' ? `${option.department_name}` : name === 'CategoryName' ? `${option.category_name}` : name === 'subCategoryName' ? `${option.sub_category_name}` : name === 'productType' ? `${option.product_type_name}` : name === 'GST' ? `${option.label}` : (name === 'uom' && typeof (option) !== 'string') ? `${option.unit}` : option}
                    value={val ? val : (name === "uom" ? "" : null)}
                    onInputChange={(event, newValue) => {
                        if (name === "uom") {
                            setUom(newValue)
                        }
                    }}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} disabled={disable} />}
                />
            </Box>
        )
    }

    const TableHeaderBtns = () => {
        return (
            <Box>
                <Tooltip title="Filter" placement='top' arrow>
                    <IconButton onClick={() => { setFilterOpen(true) }}><FilterAltIcon color='primary' /></IconButton>
                </Tooltip>
            </Box>
        )
    }

    const tableView = () => {
        const grpDelete = () => {
            setisDelete(true)
        }
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText fromStore={true} isDelete={delIDs?.length > 0} removeData={grpDelete.bind(this)} renderComponent={TableHeaderBtns} />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = productList.filter((row) => selectedIDs.has(row.sno));
            let FinalData = []
            selectedRows.forEach((item) => {
                FinalData.push(item.id)
            })
            setdelIDs(FinalData)
        }

        productList?.forEach((element, index) => element.sno = index + 1)
        const columns = [
            {
                field: 'product_code', headerName: 'Product ID', flex: 0.08,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.product_code ? params?.row?.product_code : '-'}</Box>)
            },
            {
                field: 'product_name', headerName: 'Product Name', flex: 0.20,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.product_name ? params?.row?.product_name : '-'}</Box>)
            },
            {
                field: 'department_name', headerName: 'Department', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.department_name ? params?.row?.department_name : '-'}</Box>)

            },
            {
                field: 'category_name', headerName: 'Category', flex: 0.15,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.category_name ? params?.row?.category_name : '-'}</Box>)

            },
            {
                field: 'sub_category_name', headerName: 'Sub Category', flex: 0.13,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.sub_category_name ? params?.row?.sub_category_name : '-'}</Box>)

            },
            {
                field: 'product_type_name', headerName: 'Product Type', flex: 0.13,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.product_type_name ? params?.row?.product_type_name : '-'}</Box>)
            },
            {
                field: 'manufacturer_name', headerName: 'Manufacture Name', flex: 0.13,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.manufacturer_name ? params?.row?.manufacturer_name : '-'}</Box>)
            },
            {
                field: 'action', headerName: 'Action', flex: 0.05,
                renderCell: (params) => (
                    <Stack direction="row" alignItems="center" spacing={4}>
                        <Stack direction="row" justifyContent="space-evenly" alignItems="center" spacing={1}>
                            <CommonEditButton size="1.5vw"
                                disable={delIDs?.length > 0}
                                onClick={() => {
                                    setdepartmentName(subCategoryList?.find((list) => (list?.id === params.row.sub_category_id)));
                                    setCategoryName(CategoryList?.find((list) => (list?.id === params.row.category_id)));
                                    setdepartmentName(departmentList?.find((list) => (list?.id === params.row.department_id)))
                                    setSubCategoryName(subCategoryList?.find((list) => (list?.id === params.row.sub_category_id)))
                                    setProductType(productTypeList?.find((list) => (list?.id === params.row.product_type_id)));
                                    setProductCode(params.row.product_code ? params.row.product_code : "");
                                    setProductName(params.row.product_name ? params.row.product_name : "");
                                    setCommonName(params.row.common_name ? params.row.common_name : "");
                                    setShortName(params.row.short_name ? params.row.short_name : "");
                                    setManufactureName(params.row.manufacturer_name ? params.row.manufacturer_name : "");
                                    setModelName(params.row.model_no ? params.row.model_no : "");
                                    setROL(params.row.rol_quantity ? params.row.rol_quantity : "");
                                    setROQ(params.row.roq_quantity ? params.row.roq_quantity : "");
                                    setGST(gstPercentage.find((list) => list?.value == params.row.gst_percentage));
                                    setHSN(params.row.hsn_code ? params.row.hsn_code : "");
                                    setUom(params.row.uom_id ? uomList.find((list) => list?.id === params.row.uom_id) : null);
                                    setIsActive(params.row.is_active);
                                    setEditID(params.row.id)
                                    setexpiry(params.row.is_expiry ? 'expiry' : 'non_expiry')
                                }} />
                        </Stack>
                    </Stack>)

            },
        ]
        return (
            <Box sx={{ height: '47vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={productList}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    // page={page}
                    // pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    // onPageChange={(newPage) => { setpage(newPage) }}
                    // onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    // rowsPerPageOptions={[10, 20, 30]}
                    // pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                    getRowClassName={(params) => params.row.is_active ? null : 'eMed_InActiveRow_store'}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }

    const clearFunction = () => {
        setdepartmentName(null);
        setCategoryName(null);
        setSubCategoryName(null);
        setProductType(null);
        setProductCode('');
        setProductName('');
        setCommonName('');
        setShortName('');
        setManufactureName('');
        setModelName('');
        setROL('');
        setROQ('');
        setGST(null);
        setHSN('');
        setFilterOpen(false);
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
        setUom(null)
        setEditID(null)
        setexpiry('non_expiry')
    }

    const deleteVendor = () => {
        try {
            RestAPIService.delete(`${Serviceurls.STORE_PRODUCT}?ids=${delIDs || []}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        getProductList()
                        closeFilter();
                        clearFunction()
                    }
                }).catch(e => {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const addVendorDetails = () => {
        try {
            if (!departmentName?.id || !CategoryName?.id || !subCategoryName?.id || !productType?.id || !ProductName || !HSN) {
                errorMessage('Please Enter All mandatory fields')
            }
            else {
                let data = {
                    'department_id': departmentName?.id,
                    'category_id': CategoryName?.id,
                    'sub_category_id': subCategoryName?.id,
                    'product_type_id': productType?.id,
                    'product_name': ProductName,
                    'common_name': CommonName,
                    'short_name': ShortName,
                    'manufacturer_name': ManufactureName,
                    'model_no': ModelName,
                    'rol_quantity': +ROL,
                    'roq_quantity': +ROQ,
                    'gst_percentage': GST?.value ? GST?.value : 0,
                    'hsn_code': HSN,
                    'is_active': isActive,
                    'uom': uom?.unit || uom || "",
                    'is_expiry': expiry === 'expiry' ? true : false,
                }
                if (EditID) {
                    data["id"] = EditID
                    RestAPIService.updateWithOutId(data, Serviceurls.STORE_PRODUCT)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getProductList()
                                getProductUom()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                } else {
                    RestAPIService.create(data, Serviceurls.STORE_PRODUCT)
                        .then((response) => {
                            if (response.data.status === 'success') {
                                successMessage(response.data.message)
                                clearFunction()
                                getProductList()
                            }
                        }).catch(e => {
                            setisloader(false)
                            if (e?.response?.data?.status === 'fail') {
                                errorMessage(e.response.data.message)
                            } else {
                                errorMessage(e.message)
                            }
                        })
                }
            }
        } catch (e) {
            errorMessage(e.message)
        }
    }

    const renderFilterScreen = () => {
        return (
            <Box component={"div"} className='eMed_rts_filter_container'>
                <Box component={"div"} className='eMed_filter_Top'>
                    <Typography variant='h6' fontWeight={600}>{"Filter"}</Typography>
                    <Button onClick={() => { setFilterOpen(false) }} className='eMed_usrconf_btn'>
                        <img src={ImagePaths.LabCloseButton.default} alt="close" className='eMed_action_img_small' />
                    </Button>
                </Box>
                <Box className='eMed_rts_middle'>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={departmentList}
                            getOptionLabel={(option) => option?.department_name}
                            value={filterdepartmentName}
                            onChange={(event, newValue) => {
                                setfilterdepartmentName(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Department'}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={CategoryList}
                            getOptionLabel={(option) => option?.category_name}
                            value={filterCategoryName}
                            onChange={(event, newValue) => {
                                setfilterCategoryName(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Catogory'}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={subCategoryList}
                            getOptionLabel={(option) => option?.sub_category_name}
                            value={filterSubCatName}
                            onChange={(event, newValue) => {
                                setfilterSubCatName(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Sub Catogory'}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={productTypeList}
                            getOptionLabel={(option) => option?.product_type_name}
                            value={filterProductTypeName}
                            onChange={(event, newValue) => {
                                setfilterProductTypeName(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Product Type'}
                                />
                            )}
                        />
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        {textBox("Manufacture Name", 'filterManuFacName', filterManuFacName, '20vw')}
                    </Box>
                    <Box className='eMed_rts_dropdown'>
                        <Autocomplete
                            size='small'
                            options={active_status}
                            getOptionLabel={(option) => option?.label}
                            value={filterActiveStatus}
                            onChange={(event, newValue) => {
                                setFilterActiveStatus(newValue)
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={'Active Status'}
                                />
                            )}
                        />
                    </Box>
                </Box>
                <Stack spacing={2} direction="row" alignItems="center" justifyContent="center">
                    <Button variant='outlined' size="small"
                        onClick={() => {
                            setfilterdepartmentName(null)
                            setfilterCategoryName(null)
                            setfilterSubCatName(null)
                            setfilterProductTypeName(null)
                            setfilterManuFacName("")
                            setFilterActiveStatus({ label: "All", value: "" })
                        }}
                        id="eMed_Config_btn">{"Clear"}</Button>
                    <Button variant='contained' size="small"
                        onClick={() => {
                            getProductList();
                            setFilterOpen(false);
                        }}
                        id="eMed_Config_btn">{"Search"}</Button>
                </Stack>
            </Box>
        )
    }

    return (
        <Box component={'div'} sx={{ height: '79.5vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} sx={{ height: '29.5vh', width: '93vw', backgroundColor: 'white', padding: '.6vw', }}>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                    <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', }}>
                        {autoComplete("Department *", 'departmentName', departmentName, departmentList, '15vw')}
                        {autoComplete("Category *", 'CategoryName', CategoryName, CategoryList?.filter((list) => list?.department_id === departmentName?.id), '15vw', (!departmentName?.id))}
                        {autoComplete("Sub Category *", 'subCategoryName', subCategoryName, subCategoryList?.filter((item) => item?.category_id === CategoryName?.id), '15vw', (!CategoryName?.id || !departmentName?.id))}
                        {autoComplete("Product Type *", 'productType', productType, productTypeList, '15vw')}
                        {textBox("Product Code", 'ProductCode', ProductCode, '15vw', true)}
                        {textBox("Product Name *", 'ProductName', ProductName, '15vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        {textBox("Common Name", 'CommonName', CommonName, '15vw')}
                        {textBox("Short Name", 'ShortName', ShortName, '15vw')}
                        {textBox("Manufacture Name", 'ManufactureName', ManufactureName, '15vw')}
                        {textBox("Model/Serial No", 'ModelName', ModelName, '15vw')}
                        {textBox("ROL", 'ROL', ROL, '15vw')}
                        {textBox("ROQ", 'ROQ', ROQ, '15vw')}
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        {autoComplete("GST %", 'GST', GST, gstPercentage, '15vw')}
                        {textBox("HSN Code *", 'HSN', HSN, '15vw')}
                        {autoComplete("UOM", 'uom', uom, uomList, '15vw')}
                        {/* <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <RadioGroup
                                value={consumable}
                                sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
                                onChange={(e) => { setconsumable(e.target.value) }}
                            >
                                <FormControlLabel value={'consumable'} control={<Radio size='small' />} label="Consumable" />
                                <FormControlLabel value={'non_consumable'} control={<Radio size='small' />} label="Non Consumable" />
                            </RadioGroup>
                        </FormControl> */}
                        <FormControl sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <RadioGroup
                                value={expiry}
                                sx={{ display: 'flex', flexDirection: 'row', marginLeft: '1vw' }}
                                onChange={(e) => { setexpiry(e.target.value) }}
                            >
                                <FormControlLabel value={'non_expiry'} control={<Radio size='small' />} label="Non Expiry" />
                                <FormControlLabel value={'expiry'} control={<Radio size='small' />} label="Expiry" />
                            </RadioGroup>
                        </FormControl>
                    </Box>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '1vw', justifyContent: 'space-between' }}>
                    <Box sx={{ display: 'flex' }}>
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' disabled={!EditID} />} label={"Active"} />
                    </Box>
                    <Box sx={{ gap: '1vw' }}>
                        <Button size='small' variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => { clearFunction() }}>Clear</Button>
                        <Button size='small' variant='contained' sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '1vw' }} onClick={() => { addVendorDetails() }}>{EditID ? "Update" : "Add"}</Button>
                    </Box>
                </Box>
            </Box>
            <Box component={'div'} sx={{ height: '47vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>
            <Drawer
                anchor={'right'}
                open={filterOpen}
                ModalProps={{ onBackdropClick: closeFilter }}
            >
                {renderFilterScreen()}
            </Drawer>
            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose.bind(this)}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={`Are you sure, Do you want to delete this product?`}
                    DeleteNotify={"If you remove this, this could be effect in entire Configuration"}
                    deleteAlertPopupClose={closeFilter.bind(this)}
                    removeData={deleteVendor.bind(this)}
                />
                : null}
        </Box>
    )
}
